export const enum StorageKeys {
    AUTHORIZATION_TOKEN = 'btcdirect_user_token',
    REFRESH_TOKEN = 'btcdirect_user_refresh_token',
    DISMISSED_ORDERS = 'btcdirect_dismissed_orders',
    PREVIOUS_ORDERS = 'btcdirect_previous_orders',
    USER_IDENTIFIER = 'btcdirect_user_identifier',
    CLIENT_TOKEN = 'btcdirect_client_token'
}
